import MainAdminAcademicPositions from "../pages/MainAdminPage/MainAdminAcademicPositions";
import MainAdminKeywordPages from "../pages/MainAdminPage/MainAdminKeywordPages";
import MainAdminArticleReport from "../pages/MainAdminPage/MainAdminArticleReport";
import { createBrowserRouter, Navigate } from "react-router-dom";
import {
    MainAdminLogs,
   
    Login,
   
      MainAdminUsers,
      MainAdminUniversities,
      MainAdminFields,
      MainAdminResearchAreaSuggestions,
      MainAdminTeachers,
      MainAdminColleges,
      MainAdminCollegeFields,
      MainAdminCollegeField,
      MainAdminCollegeFieldTeachers,
      UserEmailes,
      Chat,
      MainAdminPublishedNewses,
      MainAdminScheduledArticles,
      MainAdminRejectedNewses,
      MainAdminNewsPendingConfirmation,
      MainAdminNewsCategory,
      MainAdminNewsCategoryAdd,
      MainAdminNewsCategoryEdit,
      MainAdminTagsCategory,
      MainAdminTagsCategoryAdd,
      MainAdminTagsCategoryEdit,
      MainAdminUploadNews,
      MainAdminEditNews,
      MainAdminUploadNewsRelease,
      MainAdminEditNewsRelease,
      MainAdminUploadNewsConfirmation,
      MainAdminPlans,
      MainAdminPlanOptions,
      MainAdminJobs,
      MainAdminJobApplies,
      Jobs,
} from "../components";

import LayoutMainAdmin from "../layout/LayoutMainAdmin";
import LayoutUser from "../layout/LayoutUser";
import SignUp from "../pages/SignUp";
import AutomationDashboard from "../pages/User/AutomationDashboard";
import CampaignCreatePage from "../pages/User/CampaignCreatePage";
import CampaignReviewPage from "../pages/User/CampaignReviewPage";
import AcademicProfilePage from "../pages/User/AcademicProfilePage";
import AdminOverview from "../pages/MainAdminPage/AdminOverview";
import Checkout from "../pages/Checkout";
import PaymentResult from "../pages/PaymentResult";
import { FEATURES } from "../config/features";
import SiteRedirect from "../components/SiteRedirect";

export const router = createBrowserRouter([
    {
        path: "/mainAdmin",
        element: <LayoutMainAdmin />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        ),
        children: [
            { path: "/mainAdmin/academicPositions", element: <MainAdminAcademicPositions /> },
            { path: "/mainAdmin/keywordPages", element: <MainAdminKeywordPages key="keywords" /> },
            { path: "/mainAdmin/countryPages", element: <MainAdminKeywordPages key="countries" countryPages /> },
            {
                index: true,
                element: <AdminOverview />
            },
            {
                path: '/mainAdmin/logs',
                element: <MainAdminLogs />
            },
            {
                path: '/mainAdmin/users',
                element: <MainAdminUsers />
            },
            {
                path: '/mainAdmin/teachers',
                element: <MainAdminTeachers/>
            },
            {
                path: '/mainAdmin/fields',
                element: <MainAdminFields/>
            },
            {
                path: '/mainAdmin/researchAreaSuggestions',
                element: <MainAdminResearchAreaSuggestions />
            },
            {
                path: '/mainAdmin/universities',
                element: <MainAdminUniversities />
            },
            {
                path: '/mainAdmin/colleges',
                element: <MainAdminColleges />
            },
            {
                path: '/mainAdmin/collegeFields',
                element: <MainAdminCollegeFields />
            },
            {
                path: '/mainAdmin/collegeField/:collegeFieldId?',
                element: <MainAdminCollegeField />
            },
            {
                path: '/mainAdmin/collegeFieldTeachears',
                element: <MainAdminCollegeFieldTeachers />
            }
            ,
            {
                path: '/mainAdmin/PublishedNewses',
                element: <MainAdminPublishedNewses />
            },
            {
                path: '/mainAdmin/ScheduledNews',
                element: <MainAdminScheduledArticles />
            },
            {
                path: '/mainAdmin/rejectedNewses',
                element: <MainAdminRejectedNewses />
            }, 
            {
                path: '/mainAdmin/newsPendingConfirmation',
                element: <MainAdminNewsPendingConfirmation />
            },
            {
                path: '/mainAdmin/plans',
                element: <MainAdminPlans/>
            },
            {
                path: '/mainAdmin/planoptions',
                element: <MainAdminPlanOptions/>
            },
            {
                path: '/mainAdmin/jobs',
                element: FEATURES.jobApplications ? <MainAdminJobs /> : <Navigate to="/mainAdmin" replace />
            },
            {
                path: '/mainAdmin/jobApplies',
                element: FEATURES.jobApplications ? <MainAdminJobApplies /> : <Navigate to="/mainAdmin" replace />
            },
             {
                path: '/mainAdmin/newsCategory',
                element: <MainAdminNewsCategory />,
                children: [
                    {
                        path: '/mainAdmin/newsCategory/add',
                        element: <MainAdminNewsCategoryAdd />
                    }, {
                        path: '/mainAdmin/newsCategory/edit',
                        element: <MainAdminNewsCategoryEdit />
                    }
                ]
            },
            {
                path: '/mainAdmin/tagsCategory',
                element: <MainAdminTagsCategory />,
                children: [
                    {
                        path: '/mainAdmin/tagsCategory/add',
                        element: <MainAdminTagsCategoryAdd />
                    }, {
                        path: '/mainAdmin/tagsCategory/edit',
                        element: <MainAdminTagsCategoryEdit />
                    }
                ]
            }, {
                path: '/mainAdmin/articles/report',
                element: <MainAdminArticleReport />
            }, {
                path: '/mainAdmin/uploadNews',
                element: <MainAdminUploadNews />,
                children: [
                    {
                        path: '/mainAdmin/uploadNews/release',
                        element: <MainAdminUploadNewsRelease />
                    }, {
                        path: '/mainAdmin/uploadNews/confirmation',
                        element: <MainAdminUploadNewsConfirmation />
                    }
                ]
            }, {
                path: '/mainAdmin/editNews',
                element: <MainAdminEditNews />,
                children: [
                    {
                        path: '/mainAdmin/editNews/release',
                        element: <MainAdminEditNewsRelease />
                    }
                ]
            },
    
         

        ]
    },

    {
        path: "/user",
        element: <LayoutUser />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        ),
        children: [
            {
                index: true,
                element: <Navigate to="/user/dashboard" replace />
            },
            {
                path: '/user/dashboard',
                element: <AutomationDashboard />
            },
            {
                path: '/user/profile',
                element: <AcademicProfilePage />
            },
            {
                path: '/user/campaign/new/study',
                element: <CampaignCreatePage goalType="Study" />
            },
            {
                path: '/user/campaign/new/job',
                element: FEATURES.jobApplications ? <CampaignCreatePage goalType="Job" /> : <Navigate to="/user/campaign/new/study" replace />
            },
            {
                path: '/user/campaign/:id/review',
                element: <CampaignReviewPage />
            },
            {
                path: '/user/chooseTemplate',
                element: <Navigate to="/user/dashboard" replace />
            },
            {
                path: '/user/newRequestApply',
                element: <Navigate to="/user/dashboard" replace />
            },
{
                path: '/user/userEmailes',
                element: <UserEmailes />
            },
            {
                path: '/user/jobs',
                element: FEATURES.jobApplications ? <Jobs /> : <Navigate to="/user/dashboard" replace />
            },
           
          

        ]
    },
    {
        path: "/SignIn",
        element: <Login />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    }
    ,{
        path: "/SignUp",
        element: <SignUp />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    }
    , {
        path: "/chat",
        element: <Chat />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    },
    {
        path: "/checkout/payment-result",
        element: <PaymentResult />,
    },
    {
        path: "/checkout",
        element: <Checkout />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    },
    {
        path: "*",
        element: <SiteRedirect />
    },
])
